"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Content.scss");
const Content = _ref => {
  let {
    closeButtonRef,
    className,
    content,
    drawerRef,
    onClose,
    onClickAway,
    onKeyDown,
    transitionClassName
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-DrawerCover', 'cds-Drawer-Type--Fullscreen', transitionClassName, className);
  const body = document.body;
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("aside", {
    "aria-modal": "true",
    className: rootClassName,
    onKeyDown: onKeyDown,
    onMouseDown: onClickAway,
    tabIndex: -1
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Drawer",
    ref: drawerRef
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, {
    "aria-labelledby": "close-drawer",
    buttonRef: closeButtonRef,
    className: "cds-Drawer-CloseButton",
    icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.close,
    onClick: onClose,
    size: _ButtonIcon.BUTTON_ICON_SIZE.medium,
    styleType: _ButtonIcon.BUTTON_ICON_STYLE_TYPE.ghost
  }), content)), body);
};
exports.Content = Content;
//# sourceMappingURL=Content.js.map